<app-load-dropdown-data  [formName]="formName" (onPrint)="onPrint($event)"></app-load-dropdown-data>
<div class="modal-header  d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">Receipt</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button" (click)="ActiveModal?.dismiss()"></app-svg-icon>
</div>
<div class="col px-3">
    <form  autocomplete="off"  ngNativeValidate #receiptForm="ngForm">
        <div class="row">
            <div class="col-12">
                <div class="row mt-2">
                    <div class="col-8 d-flex gap-1">
                        <label for="" class="f-14 font-semibold text-gray-color text-nowrap mb-0">
                          Entry By<span class="text-color-danger">*</span>
                        </label>
                        <div class="col p-l-r ms-3">
                        <app-select 
                        [options]="data?.entryByList"
                        [selectedValue]="formModel?.entryBy"
                        (valueChanged)="formModel.entryBy=$event; getDataBuSchemeID($event)"
                        [id]="'entryById'" 
                        [name]="'entryBy'" 
                        [isDisabled]="false" 
                        [ngClass]="{'border-red':!this.formModel?.entryBy && receiptFormSubmit}"
                        [isRequired]="true">
                      </app-select>
                    </div>
                    </div>

                </div>
                <div class="row mt-11">
                    <div class="col-4 gap-2 d-flex">
                        <div class="d-flex align-items-center">
                          <label for=""
                            class="f-14 font-semibold  text-gray-color text-nowrap mb-0">
                           Gold Rate/Gm<span *ngIf="this.data?.redemptionOn=='Amount'? false : true" class="text-color-danger">*</span>
                          </label>
                        </div>
                        <div class="col pe-1 me-2">
                          <app-input 
                            onlyNumbers 
                            [inputClass]="'text-end'"
                            [inputName]="'gold_Rate'" 
                            [inputType]="'text'"
                            [decimalPlaces]="2"
                            [inputId]="'gold_RateId'"
                            [inputValue]="formModel.goldRate"
                            (keyup)="onKeydown($event)"
                            (inputValueEmit)="formModel.goldRate=$event"
                            [isRequired]="this.data?.redemptionOn=='Amount'? false : true"
                            [readOnly]="this.data?.redemptionOn=='Amount'? true : false"
                            [ngClass]="{'input-border-red' : !formModel?.goldRate && receiptFormSubmit && this.data?.redemptionOn=='Gold'}"
                            >
                          </app-input>
                        </div>
                      </div>
                      <div class="col-4 gap-2 d-flex">
                        <div class="d-flex align-items-center">
                          <label for=""
                            class="f-14 font-semibold  text-gray-color text-nowrap mb-0">
                           Gold Wt.<span *ngIf="this.data?.redemptionOn=='Amount'? false : true" class="text-color-danger">*</span>
                          </label>
                        </div>
                        <div class="col ms-4 ps-1 pe-2">
                          <app-input 
                            onlyNumbers 
                            [inputClass]="'text-end'"
                            [inputName]="'goldWt'" 
                            [inputType]="'text'"
                            [decimalPlaces]="3"
                            [inputId]="'goldWtId'"
                            [inputValue]="formModel.goldWeight"
                            (inputValueEmit)="formModel.goldWeight=$event"
                            [isRequired]="this.data?.redemptionOn=='Amount'? false : true"
                            [readOnly]="this.data?.redemptionOn=='Amount'? true : false"
                            [ngClass]="{'input-border-red' : !formModel?.goldWeight && receiptFormSubmit && this.data?.redemptionOn=='Gold'}">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-4 d-flex gap-2">
                        <div class="d-flex align-items-center">
                            <label for=""
                            class="f-14 font-semibold pe-1 text-gray-color text-nowrap mb-0">
                            Inst. Amount
                        </label>
                        </div>
                        <div class="d-flex align-items-center">
                            <app-input 
                            class="install-amount " 
                            onlyNumbers 
                            [inputClass]="'text-end'"
                            [inputName]="'currencyExchange1'" 
                            [decimalPlaces]="2" 
                            [inputValue]="formModel?.amount"
                            (inputValueEmit)="formModel.amount=$event"
                            [inputType]="'text'" 
                            [readOnly]="true"
                            [isRequired]="true">
                        </app-input>
                        </div>
                    </div>
                    <div class="col-4 d-flex gap-2">
                        <div class="d-flex align-items-center">
                            <label for="payment" class="f-14 font-semibold pe-1 text-gray-color text-nowrap mb-0">
                                Payment Date<span *ngIf="this.data?.redemptionOn=='Amount'? false : true" class="text-color-danger">*</span>
                            </label>
                        </div>
                        <div class="col">
                            <app-input-datepicker-renderer
                            [inputDate]="formModel.paymentDate"
                            [id]="'paymentDate'"  
                            [inputDatepickerName]="'payment'"
                            (dateChanged)="selectedpaymentDate($event)" 
                            class="input-group custom-height"
                            [isRequired]="this.data?.redemptionOn=='Amount'? false : true"
                           >
                        </app-input-datepicker-renderer>
                        </div>
                    </div>
                    <div *ngIf="data?.showMonthDropdown" class="col-4 d-flex gap-3">
                        <div class="d-flex align-items-center">
                            <label for="installment" class="f-14 mb-0 font-semibold pe-1 text-gray-color text-nowrap">
                                Inst. Date
                            </label>
                        </div>
                        <div class="col ms-3">
                            <app-input-datepicker-renderer 
                            [inputDate]="data?.formModel?.installmentDate" 
                            [inputDatepickerName]="'installment'"
                            [id]="'installmentDate'"   
                            (dateChanged)="selecteIntallmentDate($event)"
                            [readOnly]="data?.formModel?.installmentDate"
                            class="input-group custom-height pe-0">
                            </app-input-datepicker-renderer>
                        </div>
                    </div>
                    <div *ngIf="!data?.showMonthDropdown" class="col-7 d-flex gap-2">
                        <div class="d-flex align-items-center me-1">
                            <label for="installment" class="f-14 mb-0 font-semibold pe-1 text-gray-color text-nowrap">
                                Inst. Month<span class="text-color-danger">*</span>
                            </label>
                        </div>
                        <div class="col-12 mt-11 pe-4">
                            <app-ng-multi-select-dropdown
                            [isShowlable]="false" 
                            [isPlusIcon]="false" 
                            [name]="'monthId'" 
                            [selectedIds]="selectedMonthIds"
                            [dropdownSettings]="DropdownSettings"
                            [data]="data?.monthDropdownList"
                            [placeholder]="'Select Month'"
                            (onSelectItem)="formModel.multipleInstallmentDates =$event;onMonthSelect($event,true)"
                            [id]="'monthId'" 
                            [isRequired]="true" 
                            [ngClass]="{'multi-select-border-red' : selectedMonthIds?.length < 1  && receiptFormSubmit && this.redemptionOn=='Gold'}"
                            >
                        </app-ng-multi-select-dropdown>
                        </div> 
                    </div>

                </div>
            </div>
            <!-- Grid -->
            <!--  -->
            <div class="col-12 p-0  flex-fill creditScheme">
                <app-payment-section 
                [formModel] = "formModel"
                [paymentSectionModel]="paymentSectionModel"
                [gridDynamicHeightClass]="'Fund_Transfer_popup'"
                [bold]="true"
                (cellValueChanged)="cellValueChanged($event)"
                (onDeleteClick)="onDeletePaymentClick($event)"
             ></app-payment-section>
            </div>
            <div class="d-flex justify-content-end  foot-button">
                <!-- close -->
                <app-button 
                    class="my-0 me-3" 
                    (click)="ActiveModal.dismiss()" 
                    [buttonLabel]="'Close'"
                    [buttonClass]="'pink_button'" 
                    [buttonType]="'button'">
                </app-button>
                <!--save-->
                <app-button class="hand" 
                *ngIf="!formModel?.paymentMasterId"
                    (click)="receiptForm?.valid ? loadDropdownDataComponent?.confirmPrintPopUp() : null"
                    [buttonLabel]="'Save'" 
                    [buttonId]="'addcreateSchemeButton'"
                    [buttonClass]="'blue_button'">
                </app-button>
                <app-button class="hand" 
                *ngIf="formModel?.paymentMasterId"
                (click)="receiptForm?.valid ? loadDropdownDataComponent?.confirmPrintPopUp() : null" 
                [buttonLabel]="'Update'" 
                [buttonId]="'addcreateSchemeButton'"
                [buttonClass]="'blue_button'">
            </app-button>
            </div>
        </div>
    </form>
    </div>
 
    <!-- Delete Cofirmation  modal -->
<ng-template #alertContent let-modal>
    <div class="modal-body pt-4 pb-4">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-center py-3">
                    <p class="theme-color-secondary f-13 w-p-200 mt-1 text-center font-regular mb-0">The total amount cannot exceed the payment amount. Please adjust the amount.</p>
                </div>
            </div>
            <div class="col-12 mt-3  d-flex justify-content-center align-items-center">
                <app-button 
                class="hand" 
                (click)="modal.dismiss('Cross click');popupOpened = !popupOpened" 
                [buttonLabel]="'Ok'" 
                [buttonId]="'ButtonOk'"
                [buttonClass]="'red_button'">
            </app-button>            
        </div>
        </div>
    </div>
</ng-template>
<!-- end -->